export default async (primaryUrl, fallbackUrl, callback) => {
    const fetchUrl = async (url) => await (await fetch(url, {mode: url.includes('//') ? 'cors' : 'no-cors'})).json();
    try {
        const data = await fetchUrl(primaryUrl);
        // array || <ie8 fallback || >=ie9,chrome...
        if (data.length > 0 || (Object.keys(data).length > 0)) {
            try {
                callback(data);
            } catch (err) {
                //handle errors related to our code instead of api issues separately,
                //  so if the 1st API request is successful, but we have issue inside callback,
                //  we do not attempt the 2nd request
                console.log({
                    err
                });
                console.trace();
            }
        } else { // Get fallback if zero items
            throw new Error('bad news data provided');
        }
    } catch (err) {
        if (fallbackUrl) {
            try {
                const data2 = await fetchUrl(fallbackUrl);
                callback(data2);
            } catch (err) {
                console.log(err);
            }
        }
    }
};
